import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOtherAgent = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 33,
	fill: "none",
	viewBox: "0 0 33 33",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 33,
		height: 33,
		fill: "#99888E",
		rx: 5
	}), /* @__PURE__ */ _jsx("g", {
		stroke: "#FBFBFB",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.575,
		children: /* @__PURE__ */ _jsx("path", { d: "M16.5 16.5a3.833 3.833 0 1 0 0-7.667 3.833 3.833 0 0 0 0 7.667M8.833 24.419q7.667-5.271 15.334 0" })
	})]
});
export default SvgOtherAgent;
